import { EntityActionNames, IEntityAction } from './IEntityAction';
import {
  isSingleEmbeddedDatasource,
  userCanDeleteRunFlowTask,
  userCanEditSchedule,
  userCanManageAlerts,
  userCanManageAnyCollection
  } from './IEntityActionHelpers';
import { Messages } from '../../../../codegen/Localize';
import { IContentInfo } from '../../../../ts/models/IContentInfo';
import { IDeleteAction as IDeleteActionApi } from '../../../../ts/ServerApi/types/actionNames';
import { deleteContentsAction } from '../../../actions/spaces/DeleteContentAction';
import { AppState } from '../../../state/AppState';
import { isSharedWithMeSpace, SpaceInfo } from '../../../state/SpaceInfo';
import { ISharedWithMeContentInfo } from '../../../../ts/models/ISharedWithMeContentInfo';

export const DeleteAction: IEntityAction<IContentInfo, IDeleteActionApi> = {
  name: EntityActionNames.Delete,
  translateName: Messages.delete_action,
  isVisible: (targetItems: IContentInfo[], state: AppState) => {
    return !isSingleEmbeddedDatasource(targetItems)
      && !isContentRelatedToSharedWithMe(targetItems, state.spaceInfo);
  },
  isClickable: (availableActions: IDeleteActionApi, targetItems: IContentInfo[], state: AppState) => {
    return !!(availableActions && availableActions.del)
      || userCanManageAlerts(state, targetItems)
      || userCanEditSchedule(state, targetItems)
      || userCanDeleteRunFlowTask(targetItems)
      || userCanManageAnyCollection(state, targetItems);
  },
  createReduxAction: (targetItems: IContentInfo[]) => deleteContentsAction(targetItems)
};

const isContentRelatedToSharedWithMe = (targetItems: IContentInfo[], spaceInfo: SpaceInfo): boolean =>  {
  // An action item for Shared With Me can appear in either SwM Space or Channel
  // An item will have valid 'sharedAt' only in SharedWithMe Space or Channel
  return isSharedWithMeSpace(spaceInfo) ||
   (targetItems.length > 0 && !!(targetItems[0] as ISharedWithMeContentInfo).sharedAt);
};
